import { render, staticRenderFns } from "./ActivityMoved.vue?vue&type=template&id=0dc3270e&scoped=true&lang=pug&"
import script from "./ActivityMoved.vue?vue&type=script&lang=js&"
export * from "./ActivityMoved.vue?vue&type=script&lang=js&"
import style0 from "./ActivityMoved.vue?vue&type=style&index=0&id=0dc3270e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3270e",
  null
  
)

export default component.exports